// import { Form, useFormik, Field, ErrorMessage, FormikProvider } from "formik";
// import Swal from "sweetalert2";
// import * as Yup from "yup";
// import { useEffect, useState } from "react";
// import { TfiReload } from "react-icons/tfi";
// import * as bie from "react-bootstrap";
// import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
// import { config } from "../CommonUtils/CommonURLS";
// import { InfoAlert } from "../CommonUtils/SweetAlerts";
// import { formatIndianNumber } from "../CommonUtils/CommonValidations";
// import PaymentReceipt from "./PaymentReceipt";

// const styles = `
//   @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700&family=Lora:wght@600;700&display=swap');

//   .pf-wrap {
//     min-height: 100vh;
//     background: #f0f4f8;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 40px 16px;
//     font-family: 'Plus Jakarta Sans', sans-serif;
//   }

//   .pf-card {
//     background: #ffffff;
//     border-radius: 24px;
//     max-width: 760px;
//     width: 100%;
//     box-shadow: 0 4px 6px rgba(0,0,0,0.04), 0 20px 60px rgba(0,0,0,0.08);
//     overflow: hidden;
//   }

//   .pf-header {
//     background: linear-gradient(120deg, #1a5276 0%, #1f6fa5 100%);
//     padding: 30px 36px 26px;
//     position: relative;
//     overflow: hidden;
//   }
//   .pf-header::after {
//     content: '';
//     position: absolute;
//     right: -50px; top: -50px;
//     width: 200px; height: 200px;
//     border-radius: 50%;
//     background: rgba(255,255,255,0.06);
//   }
//   .pf-header::before {
//     content: '';
//     position: absolute;
//     right: 60px; bottom: -70px;
//     width: 160px; height: 160px;
//     border-radius: 50%;
//     background: rgba(255,255,255,0.04);
//   }
//   .pf-header-tag {
//     display: inline-block;
//     background: rgba(255,255,255,0.15);
//     border-radius: 20px;
//     padding: 4px 12px;
//     font-size: 10px;
//     font-weight: 600;
//     letter-spacing: 2.5px;
//     text-transform: uppercase;
//     color: rgba(255,255,255,0.85);
//     margin-bottom: 10px;
//   }
//   .pf-header h4 {
//     font-family: 'Lora', serif;
//     font-size: 24px;
//     font-weight: 700;
//     color: #fff;
//     margin: 0;
//     position: relative;
//     z-index: 1;
//   }
//   .pf-header-sub {
//     margin-top: 6px;
//     font-size: 12px;
//     color: rgba(255,255,255,0.6);
//     position: relative;
//     z-index: 1;
//   }

//   .pf-body {
//     padding: 32px 36px 36px;
//   }

//   .pf-info-row {
//     display: flex;
//     gap: 14px;
//     margin-bottom: 28px;
//     flex-wrap: wrap;
//   }
//   .pf-chip {
//     flex: 1;
//     min-width: 140px;
//     background: #f7fafc;
//     border: 1px solid #e2eaf2;
//     border-radius: 12px;
//     padding: 12px 16px;
//   }
//   .pf-chip .chip-label {
//     font-size: 10px;
//     font-weight: 600;
//     letter-spacing: 1.8px;
//     text-transform: uppercase;
//     color: #7a9bbf;
//     margin-bottom: 5px;
//   }
//   .pf-chip .chip-value {
//     font-size: 14px;
//     font-weight: 600;
//     color: #1a3c5e;
//   }

//   .pf-section-label {
//     font-size: 10px;
//     font-weight: 700;
//     letter-spacing: 2px;
//     text-transform: uppercase;
//     color: #7a9bbf;
//     margin-bottom: 14px;
//   }

//   .pf-divider {
//     border: none;
//     border-top: 1px solid #eef2f7;
//     margin: 24px 0;
//   }

//   .pf-amount-box {
//     background: linear-gradient(135deg, #eaf4fb 0%, #f0f8ff 100%);
//     border: 1px solid #c5dff0;
//     border-radius: 16px;
//     padding: 22px 24px;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     flex-wrap: wrap;
//     gap: 14px;
//     margin-bottom: 28px;
//   }
//   .pf-amount-label {
//     font-size: 12px;
//     color: #6b8faf;
//     margin-bottom: 6px;
//     font-weight: 500;
//   }
//   .pf-amount-value {
//     font-family: 'Lora', serif;
//     font-size: 30px;
//     font-weight: 700;
//     color: #1a5276;
//     letter-spacing: 0.5px;
//   }
//   .pf-amount-sub {
//     font-size: 12px;
//     color: #8bafc8;
//     margin-top: 5px;
//   }
//   .pf-badge {
//     background: #fff;
//     border: 1.5px solid #c5dff0;
//     border-radius: 20px;
//     padding: 6px 16px;
//     font-size: 10px;
//     font-weight: 700;
//     letter-spacing: 1.5px;
//     text-transform: uppercase;
//     color: #1a5276;
//     white-space: nowrap;
//   }

//   .pf-captcha-row {
//     display: flex;
//     align-items: flex-start;
//     gap: 14px;
//     flex-wrap: wrap;
//   }
//   .pf-captcha-box {
//     background: #f7fafc;
//     border: 1.5px dashed #b0cfe4;
//     border-radius: 12px;
//     padding: 10px 18px;
//     display: flex;
//     align-items: center;
//     gap: 12px;
//     min-width: 155px;
//   }
//   .pf-captcha-box .c-text {
//     font-family: 'Lora', serif;
//     font-size: 22px;
//     font-weight: 700;
//     color: #1a5276;
//     letter-spacing: 7px;
//     user-select: none;
//   }
//   .pf-reload {
//     background: none;
//     border: none;
//     padding: 0;
//     cursor: pointer;
//     color: #7a9bbf;
//     display: flex;
//     align-items: center;
//     transition: color 0.2s, transform 0.35s;
//   }
//   .pf-reload:hover {
//     color: #1a5276;
//     transform: rotate(180deg);
//   }
//   .pf-input-wrap {
//     display: flex;
//     flex-direction: column;
//     gap: 5px;
//   }
//   .pf-input {
//     background: #f7fafc !important;
//     border: 1.5px solid #d0e3f0 !important;
//     border-radius: 12px !important;
//     color: #1a3c5e !important;
//     padding: 11px 16px !important;
//     font-family: 'Plus Jakarta Sans', sans-serif !important;
//     font-size: 14px !important;
//     min-width: 160px;
//     transition: border-color 0.2s, box-shadow 0.2s !important;
//   }
//   .pf-input:focus {
//     border-color: #1a5276 !important;
//     box-shadow: 0 0 0 3px rgba(26,82,118,0.08) !important;
//     outline: none !important;
//     background: #fff !important;
//   }
//   .pf-input::placeholder {
//     color: #aac4d8 !important;
//   }
//   .pf-err {
//     font-size: 11px;
//     color: #e74c3c;
//   }

//   .pf-btn {
//     background: linear-gradient(120deg, #1a5276, #1f6fa5) !important;
//     border: none !important;
//     border-radius: 12px !important;
//     color: #fff !important;
//     font-family: 'Plus Jakarta Sans', sans-serif !important;
//     font-size: 14px !important;
//     font-weight: 700 !important;
//     padding: 12px 28px !important;
//     cursor: pointer !important;
//     transition: box-shadow 0.2s, transform 0.15s !important;
//     white-space: nowrap;
//     letter-spacing: 0.3px;
//   }
//   .pf-btn:hover {
//     box-shadow: 0 8px 24px rgba(26,82,118,0.28) !important;
//     transform: translateY(-1px) !important;
//   }
//   .pf-btn:active {
//     transform: translateY(0) !important;
//   }

//   .pf-note {
//     background: #fff8f0;
//     border: 1px solid #fddcb5;
//     border-left: 4px solid #e67e22;
//     border-radius: 0 12px 12px 0;
//     padding: 14px 18px;
//     margin-top: 28px;
//     display: flex;
//     gap: 12px;
//     align-items: flex-start;
//   }
//   .pf-note-icon {
//     font-size: 16px;
//     margin-top: 1px;
//     flex-shrink: 0;
//   }
//   .pf-note-title {
//     font-size: 11px;
//     font-weight: 700;
//     letter-spacing: 1.5px;
//     text-transform: uppercase;
//     color: #c0652b;
//     margin-bottom: 5px;
//   }
//   .pf-note-text {
//     font-size: 13px;
//     color: #7d5a3c;
//     line-height: 1.65;
//   }
// `;

// export default function PaymentForm({ serviceTitle, goNext }) {

//   console.log("serviceTitle", serviceTitle)

//   const user_id = sessionStorage.getItem('user_id');
//   const username = sessionStorage.getItem("user_name");
//   const FinalSubmitFlag = localStorage.getItem("FinalSubmitFlag");
//   const PaymentFlag = localStorage.getItem("PaymentFlag");
//   const serviceKeyMap = {
//     "Merger of Institutions": "merge_ofinstructions",
//     "Conversion of the Institution": "type_converstions",
//     "Closure of Institution": "closure_of_institutions",
//     "Trust / Society Name Change": "society_name_change",
//     "Programme / Intake Changes": "intake_changes",
//     "Shifting of the Institution": "shifting",
//     "Change of Institution Name": "change_of_inst_name",
//     "Extension of Permission (EoP)": "eop",
//     "Management Change": "management",
//     "Conversion of Program": "conversion_program",
//     "New Program": "new_program",
//     "Additional Section": "additional_sec",


//   };

//   let currentServiceKey = "";
//   if (user_id?.startsWith("2026")) {
//     currentServiceKey = "new_college";
//   } else {
//     currentServiceKey = serviceKeyMap[serviceTitle] ?? "";
//   }


//   console.log("currentServiceKey", currentServiceKey)
//   function generateCaptcha(length = 5) {
//     const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//     const array = new Uint32Array(length);
//     crypto.getRandomValues(array);
//     return Array.from(array, num => chars[num % chars.length]).join('');
//   }

//   const [captcha, setCaptchaa] = useState('');
//   useEffect(() => { setCaptchaa(generateCaptcha()); }, []);
//   const handleRefresh = () => setCaptchaa(generateCaptcha());

//   useEffect(() => {
//     const checkDevice = () => { };
//     checkDevice();
//     window.addEventListener("resize", checkDevice);
//     return () => window.removeEventListener("resize", checkDevice);
//   }, []);

//   useEffect(() => {
//     const handlePageShow = (event) => {
//       if (event.persisted) {
//         const hasReloaded = localStorage.getItem("hasReloaded");
//         if (hasReloaded === 'true') {
//           localStorage.setItem("hasReloaded", "false");
//           window.location.reload();
//         }
//       }
//     };
//     window.addEventListener('pageshow', handlePageShow);
//     return () => window.removeEventListener('pageshow', handlePageShow);
//   }, []);

//   const handlePaymentInitiate = (url, values) => {
//     CommonAxiosPost(url, values).then((res) => {
//       if (res.data !== null) {
//         if (res.data.scode === "01") {
//           const form = document.createElement("form");
//           form.method = "POST";
//           form.action = "https://pgi.billdesk.com/pgidsk/PGIMerchantPayment";
//           form.style.display = "none";
//           const input = document.createElement("input");
//           input.type = "hidden";
//           input.name = "msg";
//           input.value = res?.data?.output;
//           form.appendChild(input);
//           document.body.appendChild(form);
//           form.submit();
//         } else if (res.data.scode === "02" || res.data.scode === "03") {
//           Swal.fire({
//             text: res.data.sdesc,
//             icon: "warning",
//             backdrop: true,
//             allowOutsideClick: false,
//           }).then((cfm) => {
//             if (cfm.isConfirmed) formIk.setFieldValue("captcha", "");
//           });
//         }
//       } else {
//         InfoAlert("Oops! Something went wrong, Please check", "warning");
//       }
//     });
//   };

//   function submitFun(values) {
//     if (captcha !== values.captcha) {
//       Swal.fire({
//         icon: 'error',
//         title: 'Invalid CAPTCHA',
//         text: 'Please try again.',
//         confirmButtonText: 'OK'
//       }).then(() => {
//         formIk.setFieldValue("captcha", '');
//         handleRefresh();
//       });
//       return;
//     }
//     handlePaymentInitiate(config.url.FAC_URL + "paymentinitiate", values);
//   }

//   const formIk = useFormik({
//     enableReinitialize: true,
//     initialValues: { amount: "1.00", captcha: '', captchaId: '', apptype: currentServiceKey },
//     // initialValues: { amount: "1.00", captcha: '', captchaId: '', apptype: "eop" },

//     validationSchema: Yup.object().shape({
//       captcha: Yup.string().required("Please enter captcha").nullable(),
//     }),


//     onSubmit: (values) => submitFun(values),
//   });



//   const [showamount, setamount] = useState([]);

//   // function GetPaymentAmount() {
//   //   CommonAxiosGet(`${config.url.FAC_URL}getpaymentamount/${currentServiceKey}`).then((res) => {

//   //     setamount(res?.data?.scode === "01" ? res.data.data || [] : []);
//   //   });
//   // }
//   function GetPaymentAmount() {
//     CommonAxiosGet(
//       `${config.url.FAC_URL}getpaymentamount/${currentServiceKey}`
//     ).then((res) => {
//       const baseAmount = Number(res?.data?.data?.[0]?.amount || 0);

//       const extraAmount =
//         res?.data?.newprogramFee_status === true
//           ? Number(
//             res?.data?.newprogramFee?.[0]?.new_programe_fee || 0
//           )
//           : 0;

//       const finalAmount = baseAmount + extraAmount;

//       setamount(res?.data?.scode === "01" ? finalAmount : 0);

//       console.log("finalAmount", finalAmount);
//     });
//   }
//   const [PaymentDetails, setPaymentDetails] = useState([]);
//   function GetPaymentDtls() {
//     CommonAxiosGet(config.url.FAC_URL + 'paymentDetails/new_college').then((res) => {
//       if (res?.data?.scode === '01') {
//         setPaymentDetails(res?.data?.paymentDetails || []);
//       }
//       else { setPaymentDetails([]); }
//     });
//   }

//   useEffect(() => {
//     // if (!hasFetchedData?.current) {
//     GetPaymentAmount();
//     // hasFetchedData.current = true
//     // }
//     // if (user_id?.startsWith("2026")) {
//     GetPaymentDtls();
//     // }
//   }, []);


//   return (
//     <>
//       <style>{styles}</style>
//       <div className="pf-wrap">
//         <FormikProvider value={formIk}>
//           <Form onChange={formIk.handleChange} onSubmit={formIk.handleSubmit} style={{ width: '100%', maxWidth: 760 }}>
//             {(user_id?.startsWith("2026") && PaymentFlag === "true") ?
//               (
//                 <PaymentReceipt ac="New College Application" paymentData={PaymentDetails} />
//               )
//               : (
//                 <div className="pf-card">

//                   {/* Header */}
//                   <div className="pf-header">
//                     {/* <div className="pf-header-tag">SBTET · A.P.</div> */}
//                     <h4>Application Payment</h4>
//                     {/* <div className="pf-header-sub">Affiliation Fee · Academic Year 2026–27</div> */}
//                   </div>

//                   {/* Body */}
//                   <div className="pf-body">

//                     {/* College Info */}
//                     <div className="pf-info-row">
//                       <div className="pf-chip">
//                         <div className="chip-label">College Code</div>
//                         <div className="chip-value">{user_id || '—'}</div>
//                       </div>
//                       <div className="pf-chip" style={{ flex: 3 }}>
//                         <div className="chip-label">College Name</div>
//                         <div className="chip-value">{username || '—'}</div>
//                       </div>
//                     </div>

//                     <hr className="pf-divider" />
//                     {(user_id?.startsWith("2026") && FinalSubmitFlag !== "true") ? (
//                       <div style={{ padding: "12px", color: "red", fontWeight: 500 }}>
//                         Please complete the college application before payment.
//                       </div>
//                     ) : (
//                       <div>
//                         {/* Payment Summary */}
//                         < div className="pf-section-label">Payment Summary</div>
//                         <div className="pf-amount-box">
//                           <div>
//                             <div className="pf-amount-label">Total Payable Amount</div>
//                             {/* <div className="pf-amount-value">₹ {formatIndianNumber(showamount[0]?.amount ?? "-")} showamount */}
//                             <div className="pf-amount-value">₹ {formatIndianNumber(showamount || "-")}

//                               {/* 30,000  */}
//                               /-   </div>
//                             {/* <div className="pf-amount-sub">Affiliation Fee ₹2,000 + 18% GST</div> */}
//                           </div>
//                           <div className="pf-badge">Non-Refundable</div>
//                         </div>

//                         <hr className="pf-divider" />

//                         {/* Captcha */}
//                         <div className="pf-section-label">Security Verification</div>
//                         <div className="pf-captcha-row">
//                           <div className="pf-captcha-box">
//                             <button type="button" className="pf-reload" onClick={handleRefresh} title="Refresh captcha">
//                               <TfiReload size={15} />
//                             </button>
//                             <span className="c-text">{captcha}</span>
//                           </div>

//                           <div className="pf-input-wrap">
//                             <Field
//                               placeholder="Enter captcha"
//                               name="captcha"
//                               className="pf-input form-control"
//                               maxLength="5"
//                               autoComplete="off"
//                             />
//                             <ErrorMessage name="captcha" component="div" className="pf-err" />
//                           </div>

//                           <button type="submit" className="pf-btn" style={{ marginTop: 1 }}>
//                             {/* Proceed to Pay &nbsp;₹  {formatIndianNumber(showamount[0]?.amount ?? "-")}   /- */}
//                             Proceed to Pay &nbsp;₹  {formatIndianNumber(showamount ?? "-")}   /-

//                           </button>
//                         </div>

//                         {/* Note */}
//                         <div className="pf-note">
//                           <div className="pf-note-icon">⚠️</div>
//                           <div>
//                             <div className="pf-note-title">Important Note</div>
//                             <div className="pf-note-text">
//                               If your payment has been deducted but you are still seeing the Payment page,
//                               your amount will be refunded to your account within 5 to 7 working days.
//                               In such case, please pay the amount again.
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>)}

//           </Form>
//         </FormikProvider>
//       </div >
//     </>
//   );
// }













import { Form, useFormik, Field, ErrorMessage, FormikProvider } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { TfiReload } from "react-icons/tfi";
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import { InfoAlert } from "../CommonUtils/SweetAlerts";
import { formatIndianNumber } from "../CommonUtils/CommonValidations";
import PaymentReceipt from "./PaymentReceipt";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700&family=Lora:wght@600;700&display=swap');

  .pf-wrap {
    min-height: 100vh;
    background: #f0f4f8;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 16px;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }

  .pf-card {
    background: #ffffff;
    border-radius: 24px;
    max-width: 760px;
    width: 100%;
    box-shadow: 0 4px 6px rgba(0,0,0,0.04), 0 20px 60px rgba(0,0,0,0.08);
    overflow: hidden;
  }

  .pf-header {
    background: linear-gradient(120deg, #1a5276 0%, #1f6fa5 100%);
    padding: 30px 36px 26px;
    position: relative;
    overflow: hidden;
  }
  .pf-header::after {
    content: '';
    position: absolute;
    right: -50px; top: -50px;
    width: 200px; height: 200px;
    border-radius: 50%;
    background: rgba(255,255,255,0.06);
  }
  .pf-header::before {
    content: '';
    position: absolute;
    right: 60px; bottom: -70px;
    width: 160px; height: 160px;
    border-radius: 50%;
    background: rgba(255,255,255,0.04);
  }
  .pf-header-tag {
    display: inline-block;
    background: rgba(255,255,255,0.15);
    border-radius: 20px;
    padding: 4px 12px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    color: rgba(255,255,255,0.85);
    margin-bottom: 10px;
  }
  .pf-header h4 {
    font-family: 'Lora', serif;
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    margin: 0;
    position: relative;
    z-index: 1;
  }
  .pf-header-sub {
    margin-top: 6px;
    font-size: 12px;
    color: rgba(255,255,255,0.6);
    position: relative;
    z-index: 1;
  }

  .pf-body {
    padding: 32px 36px 36px;
  }

  .pf-info-row {
    display: flex;
    gap: 14px;
    margin-bottom: 28px;
    flex-wrap: wrap;
  }
  .pf-chip {
    flex: 1;
    min-width: 140px;
    background: #f7fafc;
    border: 1px solid #e2eaf2;
    border-radius: 12px;
    padding: 12px 16px;
  }
  .pf-chip .chip-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 1.8px;
    text-transform: uppercase;
    color: #7a9bbf;
    margin-bottom: 5px;
  }
  .pf-chip .chip-value {
    font-size: 14px;
    font-weight: 600;
    color: #1a3c5e;
  }

  .pf-section-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #7a9bbf;
    margin-bottom: 14px;
  }

  .pf-divider {
    border: none;
    border-top: 1px solid #eef2f7;
    margin: 24px 0;
  }

  .pf-amount-box {
    background: linear-gradient(135deg, #eaf4fb 0%, #f0f8ff 100%);
    border: 1px solid #c5dff0;
    border-radius: 16px;
    padding: 22px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 14px;
    margin-bottom: 28px;
  }
  .pf-amount-label {
    font-size: 12px;
    color: #6b8faf;
    margin-bottom: 6px;
    font-weight: 500;
  }
  .pf-amount-value {
    font-family: 'Lora', serif;
    font-size: 30px;
    font-weight: 700;
    color: #1a5276;
    letter-spacing: 0.5px;
  }
  .pf-amount-sub {
    font-size: 12px;
    color: #8bafc8;
    margin-top: 5px;
  }
  .pf-badge {
    background: #fff;
    border: 1.5px solid #c5dff0;
    border-radius: 20px;
    padding: 6px 16px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #1a5276;
    white-space: nowrap;
  }

  .pf-captcha-row {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    flex-wrap: wrap;
  }
  .pf-captcha-box {
    background: #f7fafc;
    border: 1.5px dashed #b0cfe4;
    border-radius: 12px;
    padding: 10px 18px;
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 155px;
  }
  .pf-captcha-box .c-text {
    font-family: 'Lora', serif;
    font-size: 22px;
    font-weight: 700;
    color: #1a5276;
    letter-spacing: 7px;
    user-select: none;
  }
  .pf-reload {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: #7a9bbf;
    display: flex;
    align-items: center;
    transition: color 0.2s, transform 0.35s;
  }
  .pf-reload:hover {
    color: #1a5276;
    transform: rotate(180deg);
  }
  .pf-input-wrap {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .pf-input {
    background: #f7fafc !important;
    border: 1.5px solid #d0e3f0 !important;
    border-radius: 12px !important;
    color: #1a3c5e !important;
    padding: 11px 16px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 14px !important;
    min-width: 160px;
    transition: border-color 0.2s, box-shadow 0.2s !important;
  }
  .pf-input:focus {
    border-color: #1a5276 !important;
    box-shadow: 0 0 0 3px rgba(26,82,118,0.08) !important;
    outline: none !important;
    background: #fff !important;
  }
  .pf-input::placeholder {
    color: #aac4d8 !important;
  }
  .pf-err {
    font-size: 11px;
    color: #e74c3c;
  }

  .pf-btn {
    background: linear-gradient(120deg, #1a5276, #1f6fa5) !important;
    border: none !important;
    border-radius: 12px !important;
    color: #fff !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    padding: 12px 28px !important;
    cursor: pointer !important;
    transition: box-shadow 0.2s, transform 0.15s !important;
    white-space: nowrap;
    letter-spacing: 0.3px;
  }
  .pf-btn:hover {
    box-shadow: 0 8px 24px rgba(26,82,118,0.28) !important;
    transform: translateY(-1px) !important;
  }
  .pf-btn:active {
    transform: translateY(0) !important;
  }

  .pf-note {
    background: #fff8f0;
    border: 1px solid #fddcb5;
    border-left: 4px solid #e67e22;
    border-radius: 0 12px 12px 0;
    padding: 14px 18px;
    margin-top: 28px;
    display: flex;
    gap: 12px;
    align-items: flex-start;
  }
  .pf-note-icon {
    font-size: 16px;
    margin-top: 1px;
    flex-shrink: 0;
  }
  .pf-note-title {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #c0652b;
    margin-bottom: 5px;
  }
  .pf-note-text {
    font-size: 13px;
    color: #7d5a3c;
    line-height: 1.65;
  }
`;

export default function PaymentTesting({ serviceTitle }) {
  const PenalityFlag = sessionStorage.getItem("Penality");

  const [isMobile, setIsMobile] = useState(false);
  FingerprintJS.load().then((fp) => {
    fp.get().then((result) => {
    });
  });

  const user_id = sessionStorage.getItem('user_id');
  const username = sessionStorage.getItem("user_name");
  const FinalSubmitFlag = localStorage.getItem("FinalSubmitFlag");
  const PaymentFlag = localStorage.getItem("PaymentFlag");
  const serviceKeyMap = {
    "Merger of Institutions": "merge_ofinstructions",
    "Conversion of the Institution": "type_converstions",
    "Closure of Institution": "closure_of_institutions",
    "Trust / Society Name Change": "society_name_change",
    "Programme / Intake Changes": "intake_changes",
    "Shifting of the Institution": "shifting",
    "Change of Institution Name": "change_of_inst_name",
    "Extension of Permission (EoP)": "eop",
    "Management Change": "management",
    "Conversion of Program": "conversion_program",
    "New Program": "new_program",
    "Additional Section": "additional_sec",
    "Closure of Course": "close_course"


  };

  let currentServiceKey = "";
  if (user_id?.startsWith("2026")) {
    currentServiceKey = "new_college";
  } else {
    currentServiceKey = serviceKeyMap[serviceTitle] ?? "";
  }


  function generateCaptcha(length = 5) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const array = new Uint32Array(length);
    crypto.getRandomValues(array);
    return Array.from(array, num => chars[num % chars.length]).join('');
  }

  const [captcha, setCaptchaa] = useState('');
  useEffect(() => { setCaptchaa(generateCaptcha()); }, []);
  const handleRefresh = () => setCaptchaa(generateCaptcha());

  useEffect(() => {
    const checkDevice = () => { };
    checkDevice();
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        const hasReloaded = localStorage.getItem("hasReloaded");
        if (hasReloaded === 'true') {
          localStorage.setItem("hasReloaded", "false");
          window.location.reload();
        }
      }
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

  const handlePaymentInitiate = (url, values) => {
    CommonAxiosPost(url, values).then((res) => {
      if (res.data !== null) {
        console.log('response data', JSON.parse(res?.data?.paymentResponse));

        if (res.data.scode === "01") {

          const paymentResponseValue = JSON.parse(res?.data?.paymentResponse);

          const form = document.createElement("form");
          form.name = "sdklaunch";
          form.id = "sdklaunch";
          form.method = paymentResponseValue?.links[1]?.method;
          form.action = paymentResponseValue?.links[1]?.href;

          form.style.display = "none";
          const bdorderid = document.createElement("input");
          bdorderid.type = "hidden";
          bdorderid.name = "bdorderid";
          bdorderid.value = paymentResponseValue?.links[1]?.parameters?.bdorderid;
          form.appendChild(bdorderid);



          const merchantid = document.createElement("input");
          merchantid.type = "hidden";
          merchantid.name = "merchantid";
          merchantid.value = paymentResponseValue?.links[1]?.parameters?.mercid;
          form.appendChild(merchantid);

          const rdata = document.createElement("input");
          rdata.type = "hidden";
          rdata.name = "rdata";
          rdata.value = paymentResponseValue?.links[1]?.parameters?.rdata;
          form.appendChild(rdata);


          document.body.appendChild(form);
          form.submit();
        } else if (res.data.scode === "02" || res.data.scode === "03") {
          Swal.fire({
            text: res.data.sdesc,
            icon: "warning",
            backdrop: true,
            allowOutsideClick: false,
          }).then((cfm) => {
            if (cfm.isConfirmed) formIk.setFieldValue("captcha", "");
          });
        }
      } else {
        InfoAlert("Oops! Something went wrong, Please check", "warning");
      }
    });
  };

  function submitFun(values) {
    if (captcha !== values.captcha) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid CAPTCHA',
        text: 'Please try again.',
        confirmButtonText: 'OK'
      }).then(() => {
        formIk.setFieldValue("captcha", '');
        handleRefresh();
      });
      return;
    }
    handlePaymentInitiate(config.url.FAC_URL + "paymentinitiate", values);
  }
  const getBrowserName = () => {
    const userAgent = navigator.userAgent;

    if (userAgent.indexOf("Firefox") > -1) {
      return "Mozilla Firefox";
    } else if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1 && userAgent.indexOf("Opera") === -1) {
      return "Google Chrome";
    } else if (userAgent.indexOf("Edg") > -1) {
      return "Microsoft Edge";
    } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
      return "Apple Safari";
    } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
      return "Opera";
    } else if (userAgent.indexOf("Trident") > -1 || userAgent.indexOf("MSIE") > -1) {
      return "Internet Explorer";
    } else {
      return "Unknown Browser";
    }
  }


  const formIk = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: "1.00", captcha: '', captchaId: '',
      apptype: currentServiceKey,
      // apptype: "eop",
      fingerprint: "3763363390",
      // fingerprint: FingerprintJS,
      useragent: navigator.userAgent,//"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/110.0.0.0 Safari/537.36",

    },
    // initialValues: { amount: "1.00", captcha: '', captchaId: '', apptype: "eop" },

    validationSchema: Yup.object().shape({
      captcha: Yup.string().required("Please enter captcha").nullable(),
    }),


    onSubmit: (values) => submitFun(values),
  });



  const [showamount, setamount] = useState([]);


  // function GetPaymentAmount() {
  //   CommonAxiosGet(`${config.url.FAC_URL}getpaymentamount/${currentServiceKey}`

  //   ).then((res) => {

  //     const baseAmount = Number(res?.data?.data?.[0]?.amount || 0);

  //     const extraAmount =
  //       res?.data?.newprogramFee_status === true
  //         ? Number(
  //           res?.data?.newprogramFee?.[0]?.new_programe_fee || 0
  //         )
  //         : 0;

  //     const finalAmount = baseAmount + extraAmount;

  //     setamount(res?.data?.scode === "01" ? finalAmount : 0);

  //     console.log("finalAmount", finalAmount);
  //   });
  // }


  function GetPaymentAmount() {
    CommonAxiosGet(`${config.url.FAC_URL}getpaymentamount/${currentServiceKey}`)
      .then((res) => {
        const baseAmount = PenalityFlag
          ? Number(res?.data?.data?.[0]?.penalty_amount || 0)
          : Number(res?.data?.data?.[0]?.amount || 0);

        const extraAmount =
          res?.data?.newprogramFee_status === true
            ? Number(res?.data?.newprogramFee?.[0]?.new_programe_fee || 0)
            : 0;

        const finalAmount = baseAmount + extraAmount;

        setamount(res?.data?.scode === "01" ? finalAmount : 0);

        console.log("finalAmount", finalAmount);
      });
  }
  const [PaymentDetails, setPaymentDetails] = useState([]);
  function GetPaymentDtls() {
    CommonAxiosGet(config.url.FAC_URL + 'paymentDetails/new_college').then((res) => {
      if (res?.data?.scode === '01') {
        setPaymentDetails(res?.data?.paymentDetails || []);
      }
      else { setPaymentDetails([]); }
    });
  }

  useEffect(() => {
    // if (!hasFetchedData?.current) {
    GetPaymentAmount();
    // hasFetchedData.current = true
    // }
    // if (user_id?.startsWith("2026")) {
    GetPaymentDtls();
    // }
  }, []);

  useEffect(() => {
    const checkDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice = /android|iphone|ipad|ipod/i.test(userAgent);

      if (isMobileDevice && window.innerWidth <= 1024) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }

      const browserName = getBrowserName();

      if (browserName === "Mozilla Firefox") {
        document.body.innerHTML = "<h3 style = 'text-align:center;color:red;' > This application does not support Mozilla Firefox.Please use a different browser.</h3> ";
        throw new Error("Blocked access for Mozilla Firefox");
      }
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);
  return (
    <>
      <style>{styles}</style>
      <div className="pf-wrap">
        <FormikProvider value={formIk}>
          <Form onChange={formIk.handleChange} onSubmit={formIk.handleSubmit} style={{ width: '100%', maxWidth: 760 }}>
            {(user_id?.startsWith("2026") && PaymentFlag === "true") ?
              (
                <PaymentReceipt ac="New College Application" paymentData={PaymentDetails} />
              )
              : (
                <div className="pf-card">

                  {/* Header */}
                  <div className="pf-header">
                    {/* <div className="pf-header-tag">SBTET · A.P.</div> */}
                    <h4>Application Payment</h4>
                    {/* <div className="pf-header-sub">Affiliation Fee · Academic Year 2026–27</div> */}
                  </div>

                  {/* Body */}
                  <div className="pf-body">

                    {/* College Info */}
                    <div className="pf-info-row">
                      <div className="pf-chip">
                        <div className="chip-label">College Code</div>
                        <div className="chip-value">{user_id || '—'}</div>
                      </div>
                      <div className="pf-chip" style={{ flex: 3 }}>
                        <div className="chip-label">College Name</div>
                        <div className="chip-value">{username || '—'}</div>
                      </div>
                    </div>

                    <hr className="pf-divider" />
                    {(user_id?.startsWith("2026") && FinalSubmitFlag !== "true") ? (
                      <div style={{ padding: "12px", color: "red", fontWeight: 500 }}>
                        Please complete the college application before payment.
                      </div>
                    ) : (
                      <div>
                        {/* Payment Summary */}
                        < div className="pf-section-label">Payment Summary</div>
                        <div className="pf-amount-box">
                          <div>
                            <div className="pf-amount-label">Total Payable Amount</div>
                            <div className="pf-amount-value">₹ {formatIndianNumber(showamount || "-")}

                              /-   </div>
                          </div>
                          <div className="pf-badge">Non-Refundable</div>
                        </div>

                        <hr className="pf-divider" />

                        {/* Captcha */}
                        <div className="pf-section-label">Security Verification</div>
                        <div className="pf-captcha-row">
                          <div className="pf-captcha-box">
                            <button type="button" className="pf-reload" onClick={handleRefresh} title="Refresh captcha">
                              <TfiReload size={15} />
                            </button>
                            <span className="c-text">{captcha}</span>
                          </div>

                          <div className="pf-input-wrap">
                            <Field
                              placeholder="Enter captcha"
                              name="captcha"
                              className="pf-input form-control"
                              maxLength="5"
                              autoComplete="off"
                            />
                            <ErrorMessage name="captcha" component="div" className="pf-err" />
                          </div>

                          <button type="submit" className="pf-btn" style={{ marginTop: 1 }}>
                            {/* Proceed to Pay &nbsp;₹  {formatIndianNumber(showamount[0]?.amount ?? "-")}   /- */}
                            Proceed to Pay &nbsp;₹  {formatIndianNumber(showamount ?? "-")}   /-

                          </button>
                        </div>

                        {/* Note */}
                        <div className="pf-note">
                          <div className="pf-note-icon">⚠️</div>
                          <div>
                            <div className="pf-note-title">Important Note</div>
                            <div className="pf-note-text">
                              If your payment has been deducted but you are still seeing the Payment page,
                              your amount will be refunded to your account within 5 to 7 working days.
                              In such case, please pay the amount again.
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>)}

          </Form>
        </FormikProvider>
      </div >
    </>
  );
}